'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Header;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _headerTitle = require('./headerTitle');

var _headerTitle2 = _interopRequireDefault(_headerTitle);

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Header(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      actions = _ref.actions;
  return _react2.default.createElement(_RenderIf2.default, {
    isTrue: !!(icon || title || actions)
  }, _react2.default.createElement('div', {
    className: 'rainbow-card_header-container'
  }, _react2.default.createElement('header', {
    className: 'rainbow-card_header'
  }, _react2.default.createElement(_RenderIf2.default, {
    isTrue: !!icon
  }, _react2.default.createElement('div', {
    className: 'rainbow-card_header-icon'
  }, icon)), _react2.default.createElement(_headerTitle2.default, {
    title: title
  })), _react2.default.createElement(_RenderIf2.default, {
    isTrue: !!actions
  }, _react2.default.createElement('div', null, actions))));
}

Header.propTypes = {
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  icon: _propTypes2.default.node,
  actions: _propTypes2.default.node
};
Header.defaultProps = {
  title: null,
  icon: null,
  actions: null
};